<template>
  <div class="order-page">
    <PageHeader :title="title">
      <Button @click="cancel">{{ getMessageByLang('cancel', 'Отмена') }}</Button>
      <Button
          :theme-color="'primary'"
          @click="handleSubmit"
          :disabled="isDisabledSave"
      >
      {{ getMessageByLang('btnSave', 'Сохранить') }}
      </Button>
    </PageHeader>

    <VLoader v-if="isLoading"/>
    <div v-if="!isLoading">
      <div v-if="order">
        <div class="custom-form order-page__form">
          <div class="form-group">
            <label>{{ getMessageByLang('orderNumber', 'Номер заказа') }}</label>
            <p class="order-page__form__value">{{ order.order_number }}</p>
          </div>

          <div class="form-group">
            <label>{{ getMessageByLang('clientText', 'Клиент') }}</label>
            <p class="order-page__form__value">{{ order.name }}</p>
          </div>

          <div class="form-group">
            <div class="status">
              <LabelRequired>{{ getMessageByLang('StatusText', 'Статус') }}</LabelRequired>
              <select class="app-select" v-model="order.status" @change="onChangeOrder">
                <option v-for="status in OrdersStatuses" :key="status" :value="status">{{ getOrderStatus(status) }}</option>
              </select>
            </div>
          </div>

          <div class="form-group">
            <label>{{ getMessageByLang('dateText', 'Дата') }}</label>
            <p class="order-page__form__value">{{ orderDate }}</p>
          </div>

          <div class="form-group">
            <label>{{ getMessageByLang('paymentTypeText', 'Способ оплаты') }} </label>
            <p class="order-page__form__value">{{ renderOrderPayment }}</p>
          </div>
        </div>

        <section class="order-page__section-product">
          <h4 class="order-page__section-product__title">{{ getMessageByLang('productText', 'Продукты') }}</h4>
          <ul class="order-page__section-product__list">
            <li v-for="product in order.orderItems" :key="product.key">
              <div class="order-page__product">
                <h6 class="order-page__product__name">{{ product.product.name }}</h6>
                <div>
                  <ol class="order-page__section-product__props">
                    <li>
                      <p>{{ getMessageByLang('textDescription', 'Описание') }}</p>
                      <p>{{ product.product.descr }}</p>
                    </li>
                  </ol>
                </div>
              </div>
            </li>
          </ul>
        </section>
      </div>
    </div>
  </div>
</template>


<script setup>
import {ref, onMounted, computed} from "vue";
import {useRoute, useRouter} from "vue-router";
import {getMessageByLang} from "@/utils/translate.js";
import {getRouterId} from "@/utils/router";
import {Button} from "@progress/kendo-vue-buttons";
import { getOrderStatus } from '../composables/orders';


import {getRespErrorMessage} from "@/utils/errors.js";
import {OrdersStatuses, OrderPaymentType} from '@/constants/Orders';

import api from "@/api";
import moment from 'moment';

import VLoader from "@/ui-kit/components/VLoader.vue";
import LabelRequired from "@/components/forms/LabelRequired.vue";
import PageHeader from "@/components/page/PageHeader.vue";

const title = getMessageByLang("orderTextTitle", "Заказ");

const router = useRouter();
const isLoading = ref(true);
const order = ref(null);
const route = useRoute();
const clients = ref([]);
const isDisabledSave = ref(true);


const cancel = () => {
  router.push('/admin/orders');
}

const orderDate = computed(() => {
  if(!order.value.order_date) return '';

  return moment(order.value.order_date).format('DD.MM.YYYY HH:mm');
})

const renderOrderPayment = computed(() => {
  if(!order.value.payment) return '';

  const value = OrderPaymentType[order.value.payment];

  if(!value) return '';

  return value;
})

const onChangeOrder = () => {
  isDisabledSave.value = false;
}

const handleSubmit = async () => {
  try {
    isLoading.value = true;

    const data = {
      client_id: order.value.client_id,
      order_date: order.value.order_date,
      status: order.value.status
    }

    await api.order.update(order.value.id, data)
    router.push('/admin/orders');

  } catch (err) {
    console.error(err);
    const message = getRespErrorMessage(err);
    alert(message);

  } finally {
    isLoading.value = false;
  }
}

const getData = async () => {
  try {
    const id = getRouterId(route.path);
    order.value = {};
    clients.value = [];

    const responseOrder = await api.order.get(id);
    order.value = responseOrder?.data?.data || {};

    const responseClients = await api.clients.getList();
    clients.value = responseClients?.data?.data || [];


  } catch (err) {
    console.error(err);

  } finally {
    isLoading.value = false;
  }
};

onMounted(() => {
  getData();
});
</script>

<style lang="scss" scoped>
.order-page {
  & label {
    font-size: 12px;
  }

  & p {
    padding: 0;
    margin: 0;
  }

  & ul {
    list-style: none;
  }

  & .form-group label {
    margin-bottom: -7px;
  }
}

.order-page__section-product__list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  list-style: decimal !important;
  margin: .5rem 0 0;
}

.order-page__section-product__props {
  & li {
    display: grid;
    grid-template-columns: 200px auto;
    gap: .5rem;
    font-size: 12px;
  }
}

.order-page__section-product__title {
  margin: 1rem 0 0;
}

.order-page__product__name {
  margin: 0 0 .5rem;
  font-size: 16px;
  font-weight: 600;
}

.order-page__form {
  margin-bottom: 1rem;
}
</style>
